<div class="triage-container">
   <div style="width: 100%; justify-content: flex-end; display: flex; margin-bottom: 20px;">
        <button mat-flat-button color="warn" (click)="triggerTopLevelEmergency()">
          <mat-icon style="margin-right: 8px;">warning</mat-icon>
          Top-Level Emergency (Code Blue)
        </button>
    </div>
  <div class="patient-search-header" style="margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
    <div style="flex: 1;">
        <app-patient-filter></app-patient-filter>
    </div>
   
  </div>

  <div *ngIf="patientId; else noPatient">
    <!-- Header and Action Buttons -->
    <div class="header-actions" style="margin-bottom: 16px;">
      <h2 style="margin-bottom: 16px;">Triage Assessment</h2>
      
      <div class="action-buttons" *ngIf="encounterId; else initializing">
        <button mat-flat-button color="accent" (click)="openTriageStepper()">
          <mat-icon style="margin-right: 8px;">play_circle</mat-icon>
          Start Triage Assessment
        </button>
        <!-- <button mat-flat-button color="warn" class="emergency-btn" (click)="triggerMedicalEmergency()">
          <mat-icon>warning</mat-icon>
          Medical Emergency
        </button> -->
      </div>

      <ng-template #initializing>
        <div style="display: flex; align-items: center; gap: 8px; padding: 12px; background: var(--mat-sys-surface-variant); border-radius: 4px;">
          <mat-icon class="spinning">sync</mat-icon>
          <span>Initializing Encounter...</span>
        </div>
      </ng-template>
    </div>

    <!-- Data Viewer -->
    <div class="viewer-section" *ngIf="encounterId">
      <mat-card appearance="outlined">
        <mat-card-content style="padding: 0;">
          <app-patient-observation [allowedTabsOverride]="allowedTabs"></app-patient-observation>
        </mat-card-content>
      </mat-card>
    </div>

  </div>

  <ng-template #noPatient>
    <mat-card appearance="outlined" class="empty-state">
      <mat-card-content style="text-align: center; padding: 40px;">
        <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: var(--mat-sys-on-surface-variant);">person_search</mat-icon>
        <h3 style="margin-top: 16px; color: var(--mat-sys-on-surface);">Search and select a patient to begin Triage</h3>
      </mat-card-content>
    </mat-card>
  </ng-template>

  <!-- High Risk Dialog Template -->
  <ng-template #highRiskDialogTemplate>
    <h2 mat-dialog-title class="warn-text">High-Risk Physical Observations</h2>
    <mat-dialog-content>
      <div class="checklist" style="display: flex; flex-direction: column; gap: 12px; margin-top: 10px;">
        <mat-checkbox *ngFor="let indicator of highRiskIndicators" [(ngModel)]="indicator.checked" color="warn">
          {{ indicator.label }}
        </mat-checkbox>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="warn" (click)="saveHighRiskIndicators()" [disabled]="isSaving">
        {{ isSaving ? 'Saving...' : 'Save Instantly' }}
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
